import Layout from '@/views/layout/Layout'
const BasicDataManagment = [
  {
    path: "/BasicDataManagment",
    component: Layout,
    redirect: "IndustryManagment", // 重定向到默认子路由
    children: [
      {
        path: "IndustryManagment",
        component: () => import("@/views/BasicDataManagment/IndustryManagment/index"),
        name: "IndustryManagment",
        meta: {
          title: "行业管理",
          noCache: true,
        },
     },
     {
        path: "IndustrySolutionsManagment",
        component: () => import("@/views/BasicDataManagment/IndustrySolutions/index"),
        name: "IndustrySolutionsManagment",
        meta: {
          title: "行业解决方案管理",
          noCache: true,
        },
     },
     {
        path: "CoreTechnology",
        component: () => import("@/views/BasicDataManagment/CoreTechnology/index"),
        name: "CoreTechnology",
        meta: {
          title: "核心技术管理",
          noCache: true,
        },
      },
      {
        path: "CoreTechnologyMode",
        component: () => import("@/views/BasicDataManagment/CoreTechnologyMode/index"),
        name: "CoreTechnologyMode",
        meta: {
          title: "核心技术模式管理",
          noCache: true,
        },
      },
      {
        path: "CoreTechnologyDetail",
        component: () => import("@/views/BasicDataManagment/CoreTechnologyDetail/index"),
        name: "CoreTechnologyMode",
        meta: {
          title: "核心技术详情管理",
          noCache: true,
        },
      },
      {
        path: "SGMIndustryManagment",
        component: () => import("@/views/BasicDataManagment/SGMIndustryManagment/index"),
        name: "SGMIndustryManagment",
        meta: {
          title: "SGM行业管理",
          noCache: true,
        },
     },
     {
        path: "SGMIndustrySolutionsManagment",
        component: () => import("@/views/BasicDataManagment/SGMIndustrySolutions/index"),
        name: "SGMIndustrySolutionsManagment",
        meta: {
          title: "SGM行业解决方案管理",
          noCache: true,
        },
     },
    ],
  },
];

export default BasicDataManagment